$(document).on("click", ".drawer-menu-btn", function (e) {
  e.preventDefault()
  const icon = $(this).find(".icon")
  const menu = $(".drawer-menu")
  const header = $(".main-header")
  const body = $("body")
  if (icon.hasClass("close")) {
    icon.removeClass("close").addClass("menu")
    menu.removeClass("active")
    header.removeClass("active")
    body.removeClass("no-overflow")
  } else {
    icon.addClass("close").removeClass("menu")
    menu.addClass("active")
    header.addClass("active")
    body.addClass("no-overflow")
  }
})

$(document).on(
  "click",
  ".drawer-menu .menu > li.has-children > a",
  function (e) {
    e.preventDefault()
    const li = $(this).parent()
    const ul = li.find(" > ul")
    if (li.hasClass("active")) {
      li.removeClass("active")
      ul.removeClass("active")
    } else {
      li.addClass("active")
      ul.addClass("active")
    }
  },
)
